/**
 * Obsługa podmiany linków pod SEO
 * By uniknąć marnowania budżetu crawlowania na adresy nieindeksowalnych zasobów, 
 * URL dla atrybutu HREF ustawiany jest z parametru data-seo-url poprzez JS
 */
app.service('dataSeoUrl', function (loading, modal) {

	function replaceSeoUrl($link) {
		if ($link.attr('data-seo-url')) {
			$link.attr('href', $link.data('seo-url').replace(/\*/g, "/").replace(/%2E/g, "."));
			$link.removeAttr('data-seo-url');
		}
	}

	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			$('body').on('click', 'a[data-seo-url]', function () {
				replaceSeoUrl($(this));
				modal.close();
				loading.redirect({
					href: $(this).attr('href'),
					soft: false
				});
			}).on('focus hover mouseenter', 'a[data-seo-url]', function () {
				replaceSeoUrl($(this));
			});
		}
	}
	return {
		init
	};
});
